import { postRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const getLinkToken = (ApplicationUid) =>
  postRequest(replaceInUrl(apiEndpoints.plaid.getToken, { ApplicationUid }));
